import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useSelector } from 'react-redux';
import { Tooltip } from 'primereact/tooltip';
import { CircleCheckBig } from 'lucide-react';

import { withLazyLoad } from '../shared/LazyLoad/WithLazyLoad';
import TaskNotification from '../shared/Topbar/TaskNotification/TaskNotificationComponent';
import { PROJECT_STATUS } from '../../constants';

const TaskSideBar = withLazyLoad(() => import('./TaskSideBar'));

const Task = ({
  myPermission,
  hideTrigger = false,
  visible: controlledVisible = undefined,
  onVisibleChange = undefined,
}) => {
  const [internalVisible, setInternalVisible] = useState(false);
  const visible = controlledVisible ?? internalVisible;
  const setVisible = onVisibleChange ?? setInternalVisible;
  const [refereshList, setRefereshList] = useState(false);
  const [checkProjectPage, setCheckProjectPage] = useState('');
  const history = useHistory();
  const location = useLocation();

  const taskNotificationCount = useSelector(
    state => state.taskNotification.taskNotificationCount
  );

  React.useEffect(() => {
    const urlParams = history?.location?.pathname;
    const viewEditParam = urlParams.split('/');
    const isProjectViewEdit = viewEditParam.slice(1, 3).join('/');
    if (
      isProjectViewEdit === PROJECT_STATUS.PROJECT_VIEW ||
      isProjectViewEdit === PROJECT_STATUS.PROJECT_EDIT ||
      isProjectViewEdit === PROJECT_STATUS.PROJECT_ADD ||
      isProjectViewEdit === PROJECT_STATUS.PROJECT_COPY ||
      isProjectViewEdit === PROJECT_STATUS.PROJECT_NEW_PROJECT ||
      isProjectViewEdit === PROJECT_STATUS.PROJECT_NEW_PROJECT_VIEW
    ) {
      setCheckProjectPage(true);
    } else {
      setCheckProjectPage(false);
    }
  }, [location]);
  const customHeader = (
    <React.Fragment>
      <div className="grid w-12 m-0 text-center justify-content-center">
        <h2 className="m-0 pl-4">Task Planner</h2>
      </div>
    </React.Fragment>
  );

  return (
    <>
      {checkProjectPage === false && !visible ? <TaskNotification /> : null}
      <div className="card flex justify-content-center">
        {visible && (
          <TaskSideBar
            visible={visible}
            setVisible={setVisible}
            refereshList={refereshList}
            setRefereshList={setRefereshList}
            customHeader={customHeader}
          ></TaskSideBar>
        )}

        {checkProjectPage ? (
          ''
        ) : (
          <>
            {taskNotificationCount ? (
              <Tooltip target=".task-icon-tooltip" />
            ) : null}
            {!myPermission && !hideTrigger && (
              <div
                className="fixed w-4rem h-4rem task-icon pt-2 border-round-md cursor-pointer"
                onClick={() => setVisible(true)}
              >
                <Button rounded severity="primary" className="p-1 ">
                  <div className="flex justify-content-center w-full h-full align-items-center relative">
                    <CircleCheckBig />
                    {taskNotificationCount ? (
                      <i
                        data-pr-tooltip={`Open: ${taskNotificationCount}`}
                        className="task-icon-tooltip text-xs"
                        data-pr-position="right"
                        data-pr-at="right+10 top"
                        data-pr-my="left center-2"
                      >
                        <span className="red-animated-dot" />
                      </i>
                    ) : null}
                  </div>
                </Button>
                <div className="text-10 mt-1 text-white">Task</div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Task;
